
import React from 'react'
import {useState} from 'react'
import {sendMessage,isTyping} from 'react-chat-engine';
import {SendOutlined} from '@ant-design/icons'
import {FaPaperclip} from "react-icons/fa"
//type message box
const MessageForm=(props)=>{
    const [value,setValue]=useState('');
    const {chatId,creds}=props;

    const handleSubmit=(event)=>{
        event.preventDefault();

        const text=value.trim();

        if(text.length>0) sendMessage(creds,chatId,{text});
        setValue('');

    }
    const handleChange=(event)=>{
        setValue(event.target.value);
        isTyping(props,chatId);

    }
    const handleUpload=(event)=>{
        sendMessage(creds,chatId,{files:event.target.files,text:''})
    }
    return(
        <form className="message-form" onSubmit={handleSubmit}>
            <label htmlFor="upload-button">
                <span className="image-button">
                    <FaPaperclip className="picture-icon"/>

                </span>
            </label>
            <input 
                className="message-input"
                placeholder="Type a message ..."
                value={value}
                onChange={handleChange}
                onSubmit={handleSubmit}
            />
          
            <input 
                type="file"
                multiple={false}
                id="upload-button"
                style={{display:'none'}}
                onChange={handleUpload}
            />
           <button type="submit" className="send-button">
                <SendOutlined className="send-icon"/>

            </button>
        </form>
         

    )
}
export default MessageForm